import React from 'react';
interface BonusProps {
  image: string;
  title: string;
  description: string;
  number: number;
}
export function BonusCard({
  image,
  title,
  description,
  number
}: BonusProps) {
  const scrollToPurchase = () => {
    const element = document.getElementById('purchase');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="bg-white rounded-xl overflow-hidden shadow-sm border border-slate-200 flex flex-col h-full hover:shadow-md transition-shadow duration-300" data-id="element-247">
      <div className="relative cursor-pointer aspect-square bg-slate-50 p-4" onClick={scrollToPurchase} data-id="element-248">
        <img src={image} alt={title} className="w-full h-full object-contain drop-shadow-md" data-id="element-249" />
        <div className="absolute top-0 right-0 bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-250">
          GRATIS HOY
        </div>
      </div>
      <div className="p-5 flex flex-col flex-grow text-center" data-id="element-251">
        <div className="text-blue-600 font-bold text-xs mb-2 uppercase tracking-wider" data-id="element-252">
          🎁 Bono #{number}
        </div>
        <h3 className="text-lg font-bold text-slate-900 mb-2 leading-tight" data-id="element-253">
          {title}
        </h3>
        <p className="text-slate-600 text-sm flex-grow leading-relaxed" data-id="element-254">
          {description}
        </p>
      </div>
    </div>;
}